export default __webpack_public_path__ + "static/media/sectionTwo.1c8f5e10.jpg";